module.exports = __webpack_public_path__ + "img/6-1_04.b0e287ca.jpg";